import { ReactNode } from "react";
import { Box } from "@mui/material";
import { ConversationStarter } from "../../layer06";
import { CompletedCheckInSummary } from "app/containers/TeamsTab/types";

export type ConversationStarterListAction = {
  label: string;
  // Renders the action as an icon-only button, with label as its tooltip.
  icon?: ReactNode;
  onClick: (starter: string) => void;
  // The starter whose action is in progress; it shows a spinner and every
  // other action is disabled until it finishes.
  pendingStarter?: string | null;
  isDisabled?: boolean;
};

type ConversationStarterListProps = {
  checkInSummary: CompletedCheckInSummary | null | undefined;
  action?: ConversationStarterListAction;
};

const MAX_CONVERSATION_STARTERS = 3;

export const ConversationStarterList = ({
  checkInSummary,
  action,
}: ConversationStarterListProps) => {
  const conversationStarters = checkInSummary?.conversationsStarted;
  if (!conversationStarters?.length) return null;

  return (
    <Box display="flex" flexDirection="column" rowGap=".75rem">
      {conversationStarters
        .slice(0, MAX_CONVERSATION_STARTERS)
        .map((content, i) => (
          <ConversationStarter
            key={content}
            number={i}
            content={content}
            actionLabel={action?.label}
            actionIcon={action?.icon}
            onAction={action ? () => action.onClick(content) : undefined}
            isActionLoading={action?.pendingStarter === content}
            isActionDisabled={!!action?.pendingStarter || action?.isDisabled}
          />
        ))}
    </Box>
  );
};
